import get from 'lodash/get';
import debounce from 'lodash/debounce';
import { ADS_CHANGE_ZONE } from 'client/actions/constants';
import { EventToolbox } from 'client/utils/event-toolbox';
import { PAGE_EVENTS } from 'client/constants/page-events';

const isZoneVisible = el => {
  const rect = el.getBoundingClientRect();
  const heightOffset = (window.innerHeight || document.documentElement.clientHeight) / 2;
  const widthOffset = (window.innerWidth || document.documentElement.clientWidth) / 2;

  return rect.top < heightOffset && rect.bottom > heightOffset && rect.left < widthOffset && rect.right > widthOffset;
};

const checkZones = (dispatch, getState, adZones) => {
  const elements = document.querySelectorAll('[data-ad-zone]');

  const state = getState();
  const adCurrentZone = get(state.pageContext, 'ads.adCurrentZone');

  Array.prototype.forEach.call(elements, element => {
    // const adZone = element.dataset.adZone;
    const adZone = element.dataset.adZone;

    if (isZoneVisible(element) && adCurrentZone !== adZone) {
      if (!adZones.includes(adZone)) {
        adZones.push(adZone);
      }

      // action to destroy all ads
      dispatch({
        type: ADS_CHANGE_ZONE,
        adCurrentZone: 'changing',
        adZones,
      });
      // action to create ads in active zone
      dispatch({
        type: ADS_CHANGE_ZONE,
        adCurrentZone: adZone,
        adZones,
      });
    }
  });
};

export const AdsZoneEngagementHandler = {
  init({ dispatch, getState }) {
    if (!get(getState(), 'featureFlags.ads')) {
      return;
    }

    let adZones;
    let removeScrollListener;
    const setScrollListener = () => {
      const scrollHandler = debounce(() => {
        checkZones(dispatch, getState, adZones);
      }, 250);

      EventToolbox.on('scroll', scrollHandler, true);

      return () => {
        EventToolbox.off('scroll', scrollHandler, true);
      };
    };

    EventToolbox.on(PAGE_EVENTS.PAGE_LOAD, () => {
      adZones = [];
      removeScrollListener = setScrollListener();
      checkZones(dispatch, getState, adZones);
    });

    EventToolbox.on(PAGE_EVENTS.PAGE_UNLOAD, () => {
      dispatch({
        type: ADS_CHANGE_ZONE,
        adZones: [],
      });
      removeScrollListener();
      removeScrollListener = null;
    });
  },
};
